import { action, autorun, computed, observable } from 'mobx';

import RegisterStore from 'bz-utilities/modules/plugins/register/stores/register';

const { localStorage = { getItem: () => null } } = window; // hack for SSR

export default class ApplicationContext {
  plugins = JSON.parse(localStorage.getItem('AllowedPlugins') || '["Empty"]');
  @observable isLoaded = !this.plugins.includes('Empty');
  @observable loginMode: string = '/login';
  @observable prefix: string = 'Development';
  @observable isEnterpriseClient: boolean = false;
  @observable isPronto: boolean = false;

  registerStore = new RegisterStore(); // hope to kill this some day

  @computed get Plugins() {
    if (!this.isLoaded || this.plugins.includes('Empty')) {
      return [];
    }
    return this.plugins;
  }

  @computed get Caseflow() {
    const isCaseflow = this.Plugins.includes('CaseflowPlugin');
    return isCaseflow;
  }

  @computed get NH() {
    return this.Plugins.includes('NuffieldPlugin');
  }

  @computed get VHG() {
    return this.Plugins.includes('VhgPlugin');
  }

  @computed get CBT() {
    return this.Plugins.includes('CbtPlugin');
  }
  @computed get Pronto() {
    const isPP = window.location.hostname.match(/pronto-network.com|pronto-network.local/g);
    return isPP;
  }

  @computed get Click() {
    const isClick = this.hostMatch('isClick', /click-hub.com|click-hub.local|click.local/g);
    return isClick;
  }

  @computed get EClinic() {
    const isEClinic = this.hostMatch('isEClinic', /e-clinic.co.uk|e-clinic.local/g);
    return isEClinic;
  }

  @computed get PPM() {
    const isPPM = this.hostMatch(
      'isPPM',
      /privatepracticemanagement.co.uk|ppm.local|privatepracticemanagement.com/g
    );
    return isPPM;
  }

  @computed get GDS() {
    const isGDS = this.hostMatch('isGDS', /gds.co.uk|gds.local/g);
    return isGDS;
  }

  private hostMatch(envCheck: string, match: RegExp): boolean {
    const { hostname } = window.location;
    return (hostname === 'localhost' && process.env[envCheck]) || !!hostname.match(match);
  }

  @computed get ReferralPortal() {
    const isReferralPortal = !!process.env.isReferralPortal; //Env for now
    return isReferralPortal;
  }

  @action.bound
  load(plugins: string[]) {
    this.plugins = plugins;
    localStorage && localStorage.setItem('AllowedPlugins', JSON.stringify(this.plugins));
    this.isLoaded = true;
  }

  @action.bound
  plugin(predicate: () => boolean, callback: () => void) {
    return autorun((reaction) => {
      if (this.isLoaded) {
        if (predicate()) {
          callback();
        }
      }
    });
  }

  @action.bound
  register(componentRegister: any) {
    this.registerStore.onMerge(componentRegister);
  }
}
